import type { ErrorRegistryShape } from '../common/common.error';

export const NOTIFICATION_ERROR = {
  /** 없거나 내 알림이 아님 */
  NOT_FOUND_NOTIFICATION: { status: 404, message: 'Notification not found' },
} as const satisfies ErrorRegistryShape;
